<template>
    <div
        :class="[
            'relative-block',
            'slim',
            `count-${layout.data.length}`
        ]"
    >
        <h3>
            <IconPlus/>{{layout.title}}
        </h3>
        <div class="related-list">
            <component
                :key="post.id"
                :is="`block-related`"
                v-for="post in layout.data"
                :post="post"
            >
                <span class="caption">{{
                    post.name
                }}</span>
            </component>
        </div>
    </div>
</template>

<script>
import IconPlus from '@/components/IconPlus'
import BlockRelated from '@/components/layout/RelativeBlock/BlockRelated'
export default {
    components: {
        IconPlus,
        BlockRelated
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.relative-block
    display: flex
    box-sizing: border-box
    flex-wrap: wrap
    @media print
        page-break-inside: avoid
        break-inside: avoid
    &.slim
        justify-content: space-between
        margin-top: 8.25%
        padding-left: 10.41667%
        padding-right: 10.41667%
        margin-bottom: 10%
    &.default
        margin-top: 10%
        margin-bottom: 8.5%
    &+.relative-block
        border-top: 1px solid #cccccc
h3
    font-size: 86px
    color: #ff2b2a
    font-weight: 500
    line-height: 1.2
    position: relative
    margin-bottom: 6.25%
    @include media-breakpoint-down($hd)
        font-size: 57.78125px
    @include media-breakpoint-down($sm)
        font-size: 28px
    @media print
        font-size: 28px
    svg
        position: absolute
        right: 100%
        margin-right: .4em
        top: .6em
        transform: translateY(-50%)
        @include media-breakpoint-down($sm)
            display: none
        @media print
            display: none
    /deep/ path
        fill: #ff2b2a
h2
    font-size: 86px
    color: #636772
    font-weight: 500
    letter-spacing: -0.03125em
    line-height: 1.0465116279
    margin-bottom: 8%
    @include media-breakpoint-down($hd)
        font-size: 57.78125px
    @include media-breakpoint-down($sm)
        font-size: 44.433333333px
.related-list
    flex-wrap: wrap
    .slim &
        display: inline-flex
        margin-left: auto
        @media print
            display: block
            margin-left: 0
        .post
            @include media-breakpoint-down($lg)
                min-width: 300px
                min-height: 0
                border: 1px solid #e0e1e3
                height: auto
            @include media-breakpoint-down($md)
                max-width: 100%
                min-width: 100%
                width: 100%
            @media print
                border: none
                min-width: 0
    .slim.technique.count-3 &
            margin-top: 6.4%
.column-list
    display: flex
    max-width: 910px
    width: 100%
    margin-left: auto
    margin-right: auto
    margin-bottom: 14%
    flex-direction: column
</style>
